var map = {
	"./WhatsApp Image 2026-05-07 at 3.30.40 PM (1).jpeg": 41276,
	"./WhatsApp Image 2026-05-07 at 3.30.40 PM (2).jpeg": 57035,
	"./WhatsApp Image 2026-05-07 at 3.30.40 PM.jpeg": 9314,
	"./WhatsApp Image 2026-05-07 at 3.30.41 PM.jpeg": 71255
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16742;